<template>
  <v-container fluid>
    <section>
    <!-- KPI summary cards -->
    <KpiCards class="mb-4" :items="kpiItems" :loading="loadingSummary" :skeleton="4" />

    <data-table
      :headers="headers"
      :items="reportCustomers"
      commit="SET_REPORT_CUSTOMERS"
      :viewItem="viewItem"
    >
      <div slot="activator" class="row mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
          <v-card-title class="px-0 pt-0 ps-products-title"> {{ $t("customer") }} </v-card-title>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <v-spacer />
      </div>
    </data-table>
    <app-custom-dialog v-model="dialog" :footer="false" title="description">
      <div slot="activator">
        <v-row>
          <v-col cols="4">{{ $t("id") }}</v-col>
          <v-col cols="8">{{ form.id }}</v-col>
          <v-col cols="4">{{ $t("first_name") }}</v-col>
          <v-col cols="8">{{ form.first_name }}</v-col>
          <v-col cols="4">{{ $t("phone_no") }}</v-col>
          <v-col cols="8">{{ form.phone_no }}</v-col>
          <!-- point -->
          <v-col cols="4">{{ $t("point") }}</v-col>
          <v-col cols="8">{{ form.point | ToNumber }}</v-col>
          <v-col cols="4">{{ $t("buy_count") }} </v-col>
          <v-col cols="8">{{ form.history_buy_count | ToNumber }}</v-col>
          <v-col cols="4">{{ $t("total_paid") }}</v-col>
          <v-col cols="8">{{
            form.history_buy_sum_total_paid | NumberFormat
          }}</v-col>
          <v-col cols="4">{{ $t("date") }}</v-col>
          <v-col cols="8">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>
    <!-- AppLoading -->
    <app-loading :overlay="overlay" />
  </section>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import TTextField from "@/components/global/TextField";
import { customerValidate } from "@/validations/shop";
import { myMixin } from "@/mixin/main";
import { custHead } from "@/utils/head";

export default {
  mixins: [customerValidate, myMixin],

  data: () => ({
    dialog: false,
    overlay: false,
    search: "",
    form: {},
    loadingSummary: true,
    summaries: [],
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummaries()]);
  },
  components: { DataTable, TTextField },
  computed: {
    kpiItems() {
      return (this.summaries || []).map((item, index) => ({
        key: index,
        title: item.title,
        icon: item.icon,
        value: item.total ?? 0,
        note: item.description ? this.$t(item.description) : "",
      }));
    },
    ...mapGetters({
      reportCustomers: "index/reportCustomers",
    }),
    headers() {
      return custHead(this);
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const body = {
        that: this,
        url: `report_customers?q=${encodeURIComponent(this.search || "")}`,
        commit: "SET_REPORT_CUSTOMERS",
      };
      await this.fetch(body);
    },

    async fetchSummaries() {
      this.loadingSummary = true;
      try {
        const { data } = await this.$http.get("get_summary_report_customers");
        if (data && data.status) {
          this.summaries = data.data;
        }
      } catch (e) {
        console.error("fetchSummaries error", e);
      } finally {
        this.loadingSummary = false;
      }
    },

    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
